import {ITEM_TYPES} from '@explorer/constants/item-types';
import {
  DELIVERY_DESTINATIONS,
  SENTINEL_HUB_ITEM_TYPES,
  STREAMABLE_ITEM_TYPES,
} from '@explorer/constants/orders';

export const IMAGE_ASSET_PERMISSION_RE = /^assets\.(.*):download$/;

/** get the asset from a single permission */
export const getAssetFromPermission = permission => {
  const match = permission.match(IMAGE_ASSET_PERMISSION_RE);
  return match && match[1];
};

/** get a list of assets from an items download perms */
export const getAssetsFromPermissions = permissions => {
  return permissions.map(permission => getAssetFromPermission(permission));
};

/**
 * Check that the permission isn't for an aux file
 * Helps determine availability for preview
 * Really just a safety check in case a user ONLY has aux file access (doubt it)
 */
export const isImageryPermission = permission => {
  const asset = getAssetFromPermission(permission);
  return asset?.indexOf('xml') === -1 && asset?.indexOf('udm') === -1;
};

export const isSkySatType = itemType => {
  const skySatTypes = [ITEM_TYPES.SKYSATSCENE, ITEM_TYPES.SKYSATCOLLECT];

  return skySatTypes.includes(itemType);
};

export const canOrderToHostedData = (itemType, assets) => {
  // Need to do the SkySat check first as it doesn't have analytic_sr
  return (
    (isSkySatType(itemType) && assets.includes('ortho_pansharpened')) ||
    (STREAMABLE_ITEM_TYPES.includes(itemType) &&
      (assets.includes('analytic_sr') ||
        assets.includes('ortho_analytic_4b_sr') ||
        assets.includes('ortho_analytic_8b_sr')))
  );
};

export const canOrderToSentinelHub = (itemType, assets) => {
  // Sentinel Hub only supports certain bundles/assets this is a hacky way to do a preliminary filter
  const SHAssets = [
    'ortho_analytic_4b_sr',
    'ortho_analytic_8b_sr',
    'ortho_analytic_4b',
    'ortho_analytic_8b',
    'ortho_analytic',
    'ortho_analytic_sr',
    'ortho_panchromatic',
  ];

  return (
    SENTINEL_HUB_ITEM_TYPES.includes(itemType) &&
    SHAssets.some(shAsset => assets.includes(shAsset))
  );
};

export const isItemStreamable = (
  item,
  destination = DELIVERY_DESTINATIONS.HOSTED_DATA
) => {
  const itemType = item.properties.item_type;
  const assets = getAssetsFromPermissions(item._permissions);

  if (destination === DELIVERY_DESTINATIONS.HOSTED_DATA) {
    return canOrderToHostedData(itemType, assets);
  } else if (destination === DELIVERY_DESTINATIONS.SENTINEL_HUB) {
    return canOrderToSentinelHub(itemType, assets);
  }

  return false;
};

export const isSentinelHubOrder = order => order.hosting?.sentinel_hub;
